var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/message-time"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-time"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.75 10.625C3.045 10.625 2.3925 10.8725 1.875 11.285C1.185 11.8325 0.75 12.68 0.75 13.625C0.75 15.2825 2.0925 16.625 3.75 16.625C4.5075 16.625 5.1975 16.34 5.73 15.875C6.3525 15.3275 6.75 14.525 6.75 13.625C6.75 11.9675 5.4075 10.625 3.75 10.625ZM4.5 13.8125C4.5 14.0075 4.395 14.195 4.23 14.2925L3.2925 14.855C3.2025 14.915 3.0975 14.9375 3 14.9375C2.8125 14.9375 2.625 14.84 2.52 14.6675C2.3625 14.3975 2.445 14.0525 2.715 13.895L3.3825 13.4975V12.6875C3.3825 12.38 3.6375 12.125 3.945 12.125C4.2525 12.125 4.5 12.38 4.5 12.6875V13.8125Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9375 2.32251H5.8125C3.675 2.32251 2.25 3.74751 2.25 5.88501V9.23001C2.25 9.49251 2.52 9.68001 2.775 9.61251C3.09 9.53751 3.4125 9.50001 3.75 9.50001C5.895 9.50001 7.665 11.24 7.86 13.3475C7.875 13.5575 8.0475 13.7225 8.25 13.7225H8.6625L11.835 15.8375C12.3 16.1525 12.9375 15.8075 12.9375 15.2375V13.7225C14.0025 13.7225 14.895 13.3625 15.5175 12.7475C16.14 12.1175 16.5 11.225 16.5 10.16V5.88501C16.5 3.74751 15.075 2.32251 12.9375 2.32251ZM11.8725 8.60751H6.8775C6.585 8.60751 6.345 8.36751 6.345 8.07501C6.345 7.77501 6.585 7.53501 6.8775 7.53501H11.8725C12.165 7.53501 12.405 7.77501 12.405 8.07501C12.405 8.36751 12.165 8.60751 11.8725 8.60751Z",
    fill: "#292D32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageTime);
export default __webpack_public_path__ + "static/media/message-time.667bb457ee0ee60453cc25745c252171.svg";
export { ForwardRef as ReactComponent };